import './main.css';
import img from './img.jpeg';


function Main(){
    return(
        <section>
            <div className="flex">
                <div className="texto">
                    <h1>ApexLoom: Suas Ideias, Nossas Páginas.</h1>
                    <p>Na ApexLoom, transformamos conceitos em Websites envolventes. Divulgue seu negócio online com designs cativantes e conversão eficiente.</p>
                </div>
                <div className="img">
                    <img src={img} alt="Imagem de um notbook com pessoas criando sites" />
                </div>
            </div>
        </section>
    )
}

export default Main;